export default "__VITE_ASSET__dINw$AWL__"